const focusNext = function (e: KeyboardEvent) {
    e.preventDefault()
    //@ts-ignore
    const parent = e.target?.form ?? document.body
    let inputs: Array<any> = Array.from(parent.querySelectorAll('input, textarea, button'));
    inputs = inputs.filter(x => x.tabIndex != -1
        && (typeof x.readOnly === 'undefined' || x.readOnly == false)
        && x.disabled == false);
    const index = inputs.indexOf(e.target);

    if (index < inputs.length) {
        inputs[index + 1].focus();
    }
}

export {
    focusNext
}